import { readScopedStorage, writeScopedStorage } from '../userPreferenceScope';

export type AppLanguage = 'en' | 'hi' | 'te';

export const LANGUAGE_STORAGE_KEY = 'ef_app_language_v1';
export const LANGUAGE_CHANGED_EVENT = 'ef-language-changed';

export const LANGUAGE_OPTIONS: { id: AppLanguage; labelKey: string; nativeLabel: string }[] = [
  { id: 'en', labelKey: 'lang.english', nativeLabel: 'English' },
  { id: 'hi', labelKey: 'lang.hindi', nativeLabel: 'हिन्दी' },
  { id: 'te', labelKey: 'lang.telugu', nativeLabel: 'తెలుగు' },
];

export function readAppLanguage(): AppLanguage {
  if (typeof localStorage === 'undefined') return 'en';
  const raw = readScopedStorage(LANGUAGE_STORAGE_KEY);
  if (raw === 'hi' || raw === 'te' || raw === 'en') return raw;
  return 'en';
}

export function writeAppLanguage(lang: AppLanguage): void {
  if (typeof localStorage === 'undefined') return;
  writeScopedStorage(LANGUAGE_STORAGE_KEY, lang);
  window.dispatchEvent(new Event(LANGUAGE_CHANGED_EVENT));
}

export function languageHtmlLang(lang: AppLanguage): string {
  if (lang === 'te') return 'te';
  if (lang === 'hi') return 'hi';
  return 'en';
}
